let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kbQU8")).then(() => parcelRequire('jayDk'));